import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MailCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Spinner } from '@/components/ui/misc';
import { AuthLayout } from '@/components/AuthLayout';
import { makeClient } from '@/lib/api';
import { useT } from '@/lib/i18n';

export function ForgotPassword() {
  const t = useT();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      // Resposta é sempre 200 (sem enumeração de e-mails); mostramos a confirmação
      // independentemente de a conta existir.
      await makeClient().POST('/auth/forgot', { body: { email } });
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <AuthLayout subtitle={t('forgot.subtitle')}>
        <div className="rounded-xl border bg-card p-8 text-center shadow-sm">
          <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-full bg-primary/12">
            <MailCheck className="size-7 text-primary" />
          </div>
          <h2 className="text-xl font-bold">{t('forgot.sentTitle')}</h2>
          <p className="mt-2 text-sm text-muted-foreground">{t('forgot.sentBody', { email })}</p>
          <Button asChild className="mt-6 w-full"><Link to="/login">{t('forgot.backToLogin')}</Link></Button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout subtitle={t('forgot.subtitle')}>
      <div className="rounded-xl border bg-card p-6 shadow-sm">
        <form onSubmit={submit} className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">{t('forgot.intro')}</p>
          <div className="flex flex-col gap-2">
            <Label htmlFor="email">{t('auth.email')}</Label>
            <Input id="email" type="email" autoComplete="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@empresa.com" />
          </div>
          <Button type="submit" disabled={busy} className="w-full">
            {busy && <Spinner className="border-primary-foreground/40 border-t-primary-foreground" />}
            {t('forgot.submit')}
          </Button>
        </form>
      </div>
      <Link
        to="/login"
        className="mt-4 block w-full text-center text-sm text-muted-foreground transition-colors hover:text-foreground"
      >
        {t('forgot.backToLogin')}
      </Link>
    </AuthLayout>
  );
}
